import React from "react";
import { SpinnerIcon } from "@/components/icons";

/** Portal loading state: one centered spinner (DD-001/DD-025). */
export const ApprovalLoadingState: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <SpinnerIcon className="w-6 h-6 text-blue-600" />
    </div>
  );
};
